import "./IntegrationTypeCardSkeleton.css";

interface IntegrationTypeCardSkeletonProps {
  index?: number;
}

export function IntegrationTypeCardSkeleton({
  index = 0,
}: IntegrationTypeCardSkeletonProps) {
  const style = { animationDelay: `${Math.min(index, 10) * 80}ms` };

  return (
    <div
      className="IntegrationTypeCardSkeleton rounded-[var(--border-radius-md,12px)] border p-5 flex flex-col"
      style={style}
      aria-hidden="true"
    >
      <div className="flex items-start gap-4">
        <div className="IntegrationTypeCardSkeleton__tile" />
        <div className="flex-1 min-w-0">
          <div className="IntegrationTypeCardSkeleton__line IntegrationTypeCardSkeleton__line--title" />
        </div>
      </div>
      <div className="IntegrationTypeCardSkeleton__line IntegrationTypeCardSkeleton__line--desc mt-4" />
      <div className="IntegrationTypeCardSkeleton__line IntegrationTypeCardSkeleton__line--desc mt-2 w-3/4" />
    </div>
  );
}
